import { connect } from 'react-redux';
import * as R from 'ramda';
import LastStep3 from './LastStep3';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  inventoryOwners: getStoreValueByProp(['inventoryOwners']),
  loading: getStoreValueByProp(['locationsLoading']),
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(LastStep3);
